<template>
  <div class="page-list unset-min-width">

    <div class="page-list-content scrollbarCss">
      <div v-if="showButton" class="scrollBtnCss" style="border-right: 1px solid #EAEDF1;margin-right:10px" @click="menubarLeft"><i class="el-icon-arrow-left" style="color:#153a6f"></i></div>

      <el-scrollbar ref="scrollContainer" :vertical="false" class="scroll-container" @wheel.native.prevent="handleScroll">
        <span v-for="(item,index) in pagelist" :key="item.path" :class="['page-list-item' ,{'active': item.open}]" @click="openPage(item)" @contextmenu="showMenu(index)">
          <a class="page-list-a">{{item.title}}</a>
          <i v-if="item.closeable&&item.open" class="el-icon-close" @click.stop="closeSelf(item)"></i>
          <i v-if="item.closeable&&!item.open" class="el-icon-close" @click.stop="closeSelf(item)"></i>
          <!-- <div class="page-seperate"></div> -->
          <!-- <img v-if="item.open" class="tabImgCss" src="@/assets/common/tabImg.png" alt=""> -->
          <context-menu :context-menu-data="contextMenuData" :transfer-index="transferIndex" :menulist="item | getMenuList" @close-self="closeSelf(item)" @close-all="closeAll" @close-oth="closeOth(item)"></context-menu>
        </span>

      </el-scrollbar>
      <div v-if="showButton" class="scrollBtnCss" style="border-left: 1px solid #EAEDF1;margin-left:10px" @click="menubarRight"><i class="el-icon-arrow-right" style="color:#153a6f"></i></div>
    </div>

  </div>
</template>
<script>
const cubic = value => Math.pow(value, 3);
const easeInOutCubic = value => value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2;
import {
  mapActions,
  mapGetters
} from 'vuex';
import ContextMenu from '@/components/ContextMenu.vue'
//import {getTransformXValue} from '../utils/utils'
export default {
  components: {
    ContextMenu
  },
  computed: {
    ...mapGetters({
      pagelist: 'page/pagelist',
    }),
    scrollWrapper() {
      return this.$refs.scrollContainer.$refs.wrap
    }
  },
  data() {
    return {
      showButton: false,
      transferIndex: null,
      contextMenuData: {
        menuName: 'tabs',
        axios: {
          x: null,
          y: null
        }
      }
    }
  },
  filters: {
    getMenuList: function (value) {
      if (value.closeable) {
        return [{
          handler: 'close-self',
          name: '关闭当前页'
        },
        {
          handler: 'close-all',
          name: '关闭所有页面'
        }, {
          handler: 'close-oth',
          name: '关闭其他页面'
        }
        ]
      } else {
        return [{
          handler: 'close-all',
          name: '关闭所有页面'
        }, {
          handler: 'close-oth',
          name: '关闭其他页面'
        }]
      }
    }
  },
  watch: {
    "pagelist.length": function (newValue, oldValue) {
      if (true) {
        // const $scrollWrapper = this.scrollWrapper
        // $scrollWrapper.scrollLeft = $scrollWrapper.scrollWidth
        setTimeout(() => {
          this.menubarRight()
        }, 0);
      }
    },
  },
  updated() {
    this.checkOverflow();
  },
  methods: {
    ...mapActions([
      "page/closePage",
      "page/clearPage",
      "page/closeOtaPage"
    ]),

    showMenu(index) {
      console.log(index)
      this.transferIndex = index // tranfer index to child component
      event.preventDefault()
      // let offet_x = getTransformXValue(document.querySelector(".page-list-ul")) //偏移量
      var x = event.clientX
      var y = event.clientY
      this.contextMenuData.axios = {
        x,
        y
      }
    },
    openPage(item) {
      console.log(item)
      if (this.$route.path != item.path) {
        this.$router.push({
          name: item.name,
          params: item.params,
          query: item.query
        })
      }
    },
    closeSelf(item) {
      console.log(item,'item');
      this['page/closePage']({
        ctx: this,
        pageM: item
      });
    },
    closeOth(item) {
      this['page/closeOtaPage']({
        ctx: this,
        pageM: item
      });
    },
    closeAll() {
      this['page/clearPage']({
        ctx: this
      });
    },
    // getLeft() {
    //   console.log(this.pagelist, 'pagelist', this.transferIndex)
    //   let tempIndex
    //   this.pagelist.forEach((item, index) => {
    //     if (item.open) {
    //       tempIndex = index - 1
    //     }
    //   });
    //   this.pagelist[tempIndex + 1].open = false
    //   this.pagelist[tempIndex].open = true
    //   const activeItems = document.getElementsByClassName('active');
    //   const $scrollWrapper = this.scrollWrapper
    //   $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft - activeItems[0].clientWidth

    //   this.$router.push({
    //     name: this.pagelist[tempIndex].name,
    //     params: this.pagelist[tempIndex].params,
    //     query: this.pagelist[tempIndex].query
    //   })
    // },
    checkOverflow() {
      let pageCssList = document.getElementsByClassName('page-list-item')
      let childWidth = 0
      for (var i = 0; i < pageCssList.length; i++) {
        childWidth = childWidth + pageCssList[i].clientWidth + 5
      }
      let parentWidth = document.getElementsByClassName('scroll-container')[0].clientWidth
      this.showButton = childWidth > parentWidth
    },
    menubarLeft() {
      let el = this.scrollWrapper
      let beginTime = Date.now();
      let beginValue = el.scrollLeft;
      let rAF = window.requestAnimationFrame || (func => setTimeout(func, 16));
      let frameFunc = () => {
        let progress = (Date.now() - beginTime) / 500;
        if (progress < 1) {
          el.scrollLeft = beginValue * (1 - easeInOutCubic(progress));
          rAF(frameFunc);
        } else {
          el.scrollLeft = 0;
        }
      };
      rAF(frameFunc);
    },
    menubarRight() {
      let el = this.scrollWrapper
      let maxScroll = el.scrollWidth - el.clientWidth;
      let beginTime = Date.now();
      let beginValue = el.scrollLeft; // 当前滚动位置
      let targetValue = maxScroll; // 目标滚动位置
      let rAF = window.requestAnimationFrame || (func => setTimeout(func, 16));
      let frameFunc = () => {
        let progress = (Date.now() - beginTime) / 500;
        if (progress < 1) {
          let currentValue = beginValue + (targetValue - beginValue) * easeInOutCubic(progress);
          el.scrollLeft = currentValue;
          rAF(frameFunc);
        } else {
          el.scrollLeft = targetValue;
        }
      };
      rAF(frameFunc);
    },
    handleScroll(e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 40
      const $scrollWrapper = this.scrollWrapper
      $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft + eventDelta / 4
    }
  },

  mounted() {
    console.log(this.pagelist, 'this.pagelist');
    this.checkOverflow()
  },

}
</script>

<style>
.scrollbarCss {
  height: 50px;
  display: flex;
  align-items: flex-end;
}

.el-scrollbar__view :first-child.page-list-item{
  padding: 0 25px;
}

.page-list-item.active {
  /*背景图片*/
  /* background: url("~@/assets/common/tabImg_left.png") no-repeat left center/30px
      100%,
    url("~@/assets/common/tabImg.png") no-repeat 30px
      center/calc(100% - 28px - 28px) 100%,
    url("~@/assets/common/tabImg_right.png") no-repeat right center/30px 100%; */
  /* padding: 0 20px;
  margin-right: 0; */
}

.tabImgCss {
  width: 100%;
  height: 40px;
  position: absolute;
  left: -5%;
}

.scrollBtnCss {
  width: 30px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  margin: auto 0;
  color: #414d6f;
}

.el-scrollbar__wrap::-webkit-scrollbar {
  display: none;
  margin-right: 0 !important;
  margin-bottom: 0 !important;
}
</style>